import { type ColumnType, LockIcon, Space, Text } from '@/components';
import { isPS } from '@/utils';
import { useTranslation } from 'react-i18next';
import type { z } from 'zod';
import type { ProjectListElementModel } from '../projects/_models/projects';

const TABLE_NAME_WIDTH = 380;

type Project = z.infer<typeof ProjectListElementModel>;

export const useProjectNameColumn = ({
  title,
  dataCount,
}: {
  title: string;
  dataCount: number;
}): ColumnType<Project> => {
  const { t } = useTranslation();

  return {
    title,
    key: 'name',
    fixed: 'left',
    // Note: 検索結果が 0 件の時に左固定のヘッダーセルがずれるのを防ぐため
    width: dataCount > 0 ? undefined : 80,
    render: (_, record) => (
      <Space
        direction="vertical"
        size="small"
        style={{ maxWidth: TABLE_NAME_WIDTH }}
      >
        <Space>
          {!isPS() && record.isLocked && (
            <LockIcon hint={t('locked-project')} />
          )}
          <Text
            weight="medium"
            text={record.name}
            maxWidth={TABLE_NAME_WIDTH - 20}
          />
        </Space>
        <Text variant="footnote" text={record.overview} maxRows={3} />
      </Space>
    ),
  };
};
